import React, { PureComponent } from "react";
import {
  FormControl,
  Input,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Search } from "@mui/icons-material";
export class SearchForm extends PureComponent {
  render() {
    const { host } = this.props;

    const trackSearchEvent = () => {
      if (typeof window.EventAnalyticsService != "undefined") {
        window.EventAnalyticsService.addEvent({
          name: "CAMPAIGN SEARCH PAGE - SEARCH",
          component_type: "MenuBar",
          component_subtype: "Complex",
        });
      }
    };

    return (
      <form
        data-testid="t-MenuBar-Complex--SearchF-form"
        className="menubar-search-form m-sm-r"
        action="/campaign_search"
        onSubmit={trackSearchEvent}>
        {window.location.host != host && (
          <input
            data-testid="t-MenuBar-Complex--SearchF-entity_host"
            name="entity_host"
            type="hidden"
            value={host}
          />
        )}
        <FormControl variant="standard">
          <InputLabel htmlFor="menu-search">Search giving options</InputLabel>
          <Input
            id="menu-search"
            name="search"
            type="text"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  data-testid="t-MenuBar-Complex--SearchF-search-giving-option"
                  aria-label="search giving options"
                  type="submit">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </form>
    );
  }
}

export default SearchForm;
